import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export const AdminReo = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/rt/reo").then((r) => setD(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!d) return null;
  return (
    <Card className="mt-5 p-6" data-testid="admin-reo-card">
      <h3 className="mb-2 font-display text-lg font-bold text-slate-900">Realtor REO applications</h3>
      {d.realtors.map((r) => (
        <div key={r.id} className="border-t border-slate-100 py-2 text-sm" data-testid={`admin-reo-${r.id}`}>
          <b>{r.name}</b> <span className="text-xs text-slate-500">{r.email}</span>
          <div className="text-xs text-slate-600">{r.progress.applied} of {r.progress.total} applied · {r.progress.approved} approved · {r.progress.failed} need help · {r.progress.payment_due} fees due</div>
        </div>))}
      {!d.realtors.length && <p className="text-sm text-slate-500">No realtors yet.</p>}
      <h4 className="mt-4 text-sm font-bold text-slate-900">Website fees</h4>
      {d.fees.map((f) => (
        <div key={f.id} className="flex flex-wrap justify-between gap-2 border-t border-slate-100 py-2 text-xs" data-testid={`admin-reo-fee-${f.id}`}>
          <span><b>{f.site_name}</b> · cost ${f.cost.toFixed(2)} · realtor charged ${f.charge.toFixed(2)}</span>
          <span className="flex gap-3"><span className="font-semibold">{f.status}</span><a href={f.pay_url} target="_blank" rel="noreferrer" className="text-blue-700 underline">Pay link</a></span>
        </div>))}
      {!d.fees.length && <p className="text-xs text-slate-500">No fees yet.</p>}
    </Card>
  );
};
